<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2022-01-05 16:54:07
 * @LastEditors: Luyaoyao
 * @LastEditTime: 2022-03-07 16:53:09
-->
<template>
  <div>
    <!-- 输入购买数弹框 -->
    <div v-if="showInputNum" class="inputNumber">
      <div class="inputNumber-d">
        <div class="inputNumber-amout">请输入数量：</div>
        <input
          v-model.number="valInputNum"
          class="inputNumber-input"
          placeholder="请输入数量"
        >
        <div class="inputNumber-bottons">
          <div class="input-enter" @click.stop="inputNumberEnter">确定</div>
          <div class="input-cancel" @click.stop="cancelNumber">取消</div>
        </div>
      </div>
    </div>
    <!--  竖版 -->
    <div
      v-if="type != 'across'"
      class="item-product"
      @click.stop="toDetail(product)"
    >
      <div class="item-div">
        <div class="item-div-img">
          <img
            v-show="
              product.ActivityInfo && product.ActivityInfo.ActivityCode == 8
            "
            class="ms-logo"
            src="@/assets/home/miaoshalogo.png"
          >
          <img
            v-show="
              product.ActivityInfo && product.ActivityInfo.ActivityCode == 5
            "
            class="ms-logo"
            src="@/assets/home/tejia.png"
          >
          <div v-show="product.IsSoldOut" class="no-store">补货中</div>
          <img :src="product.Logo" class="product-logo">
          <span
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityDiscount"
            class="product-activitydiscount"
          >{{ product.ActivityInfo.ActivityDiscount }}折</span>
        </div>
        <div v-if="product.EstimatedTime" class="activty-contdown">
          <span> 预计到货需{{ getDay(product.EstimatedTime) }}天</span>
          <span class="timer">
            <van-count-down :time="getTimer(product.EstimatedTime)">
              <template #default="timeData">
                <span class="block">{{ timeData.hours }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </span>
        </div>
        <div v-if="false" class="activty-position">
          <div>距离活动剩余天数：8天</div>
        </div>

        <!-- 换购 -->
        <div
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 4"
          class="img-position"
        >
          <div v-if="product.ActivityInfo">
            {{ _truncature(product.ActivityInfo.ActivityDescribe,12) }}
          </div>
        </div>

        <!-- 满赠 -->
        <div
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 3"
          class="img-position-manzeng"
        >
          <div v-if="product.ActivityInfo">
            {{ _truncature(product.ActivityInfo.ActivityDescribe,12) }}
          </div>
        </div>

        <!-- 满减 -->
        <div
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 6"
          class="img-position-manjian"
        >
          <div v-if="product.ActivityInfo">
            {{ _truncature(product.ActivityInfo.ActivityDescribe,12) }}
          </div>
        </div>
        <!-- 满返 -->
        <div
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 7"
          class="img-position-manfan"
        >
          <div v-if="product.ActivityInfo">
            {{ _truncature(product.ActivityInfo.ActivityDescribe,12) }}
          </div>
        </div>

        <div
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 8"
          class="progress"
        >
          <el-progress
            :text-inside="true"
            :stroke-width="15"
            :percentage="product.ActivityInfo.ProgressBar"
            status="exception"
          />
        </div>

        <span
          v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 8"
          class="sale-num"
        >已售{{ product.SoldNumber }}</span>
        <div class="item-div-info">
          <div class="item-div-titleOne">
            <img v-if="product.IsNewProduct" src="@/assets/home/newProduct.png">
            <span class="product_title">{{ product.SkuName }}</span>
          </div>
          <div class="item-div-titleSecond">
            <span>{{ product.Specifications }}/{{ product.Unit }}</span>
          </div>
          <div class="item-div-titleSecond">
            <span>效期优于{{ product.Validity }}</span>
          </div>
          <div
            v-show="product.IsOutBusinessScope"
            class="item-div-IsOutBusinessScope"
          >
            超出经营范围
          </div>
          <div v-show="true" class="item-div-titleThree">
            <img
              v-show="
                ((product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 8) ||
                  (product.ActivityInfo &&
                    product.ActivityInfo.ActivityCode == 5)) &&
                  !product.IsOutBusinessScope
              "
              src="@/assets/home/down.png"
            >
            <!-- 原价 -->
            <span
              v-if="!product.IsOutBusinessScope"
            >￥{{ product.PriceLimit }}</span>
            <!-- 优惠价 -->
            <span
              v-show="
                ((product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 8) ||
                  (product.ActivityInfo &&
                    product.ActivityInfo.ActivityCode == 5)) &&
                  !product.IsOutBusinessScope
              "
            >￥{{ product.Price }}</span>
            <div
              v-show="
                !product.IsOutBusinessScope&& product.ActivityInfo && product.ActivityInfo.ActivityCode == 6
              "
              class="active-price-div"
            >
              折后约￥{{ product.Price }}
            </div>
          </div>
          <div v-show="!product.IsOutBusinessScope" class="item-div-titleFour">
            <span>最低零售 ¥{{ product.RetailPrice }} | 毛利率
              {{
                _showProductProfit(
                  product.RetailPrice,
                  _getProductPrice(product.ActivityPrice, product.PriceLimit)
                )
              }}
              %</span>
          </div>
          <div class="item-div-titleFive">
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 8 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              秒杀
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 3 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满赠
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 4 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              换购
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 6 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满减
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 7 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满返
            </div>

            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 5 &&
                  !product.IsOutBusinessScope
              "
              class="tejiatag"
            >
              特价
            </div>

            <div
              v-show="product.MedicalType != 0 && !product.IsOutBusinessScope"
              class="typetag"
            >
              {{
                product.MedicalType == 1
                  ? '甲类'
                  : product.MedicalType == 2
                    ? '乙类'
                    : '医保'
              }}
            </div>
            <div
              v-show="product.CountryCode && !product.IsOutBusinessScope"
              class="codetag"
            >
              国家码
            </div>
            <div v-if="!product.IsOutBusinessScope&&product.CouponInfos" class="coupon_class">
              {{ _truncature(product.CouponInfos[0].Name, 4) }}
            </div>
          </div>
          <div
            v-show="!product.IsOutBusinessScope"
            class="item-div-btn"
            @click.stop="stepper"
          >
            <van-stepper
              v-show="!product.IsOutBusinessScope && !product.IsSoldOut"
              v-model="product.Count"
              :min="product.StartNumber"
              :max="product.MaxNumber"
              :step="product.StepLengthNumber"
              :disable-plus="
                product.Count >= product.Stock ||
                  (product.MaxNumber && product.Count >= product.MaxNumber) ||
                  (product.MaxNumber && product.Count >= product.MaxNumber)
              "
              integer
              @focus="onFocus($event)"
            />

            <div
              v-if="product.IsSoldOut"
              :class="!product.ArrivalNotice ? 'btn-notice' : 'btn-notice-read'"
              @click.stop="SubNotice()"
            >
              {{ !product.ArrivalNotice ? '到货通知' : '已订阅' }}
            </div>
            <div
              v-if="!product.IsOutBusinessScope && !product.IsSoldOut"
              class="btn"
              @click.stop="addShoppingCart(product)"
            >
              加入购物车
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 横版 -->
    <div v-else class="item-across-product" @click.stop="toDetail(product)">
      <div class="item-div">
        <div class="item-div-img">
          <img :src="product && product.Logo" class="logo">
          <img
            v-show="
              product.ActivityInfo && product.ActivityInfo.ActivityCode == 5
            "
            class="tejia-logo"
            src="@/assets/home/tejia.png"
          >
          <!-- <img
          v-show="
            product.ActivityInfo && product.ActivityInfo.ActivityCode == 7
          "
          class="manfane-logo"
          src="@/assets/home/manfanlogo.png"
        > -->
          <!-- 满减 -->
          <div
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 6"
            class="img-position-manjian"
          />

          <!-- 满返 -->
          <div
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 7"
            class="img-position-manfan"
          />
          <!-- 换购 -->
          <div
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 4"
            class="img-position"
          />

          <!-- 满赠 -->
          <div
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 3"
            class="img-position-manzeng"
          />

          <div
            v-if="
              product.ActivityInfo && (product.ActivityInfo.ActivityCode == 6||product.ActivityInfo.ActivityCode == 7||product.ActivityInfo.ActivityCode == 4||product.ActivityInfo.ActivityCode == 3)
            "
            class="manjian-text"
            style="margin-left: 46px;"
          >
            {{ _truncature(product.ActivityInfo.ActivityDescribe,12) }}
          </div>

          <div
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 8"
            class="progress"
          >
            <el-progress
              :text-inside="true"
              :stroke-width="15"
              :percentage="product.ActivityInfo.ProgressBar"
              status="exception"
            />
          </div>
          <span
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityCode == 8"
            class="sale-num"
          >已售{{ product.SoldNumber }}</span>
          <div v-show="false" class="activty-position">距离活动剩余天数：8天</div>

          <div v-show="product.IsSoldOut" class="no-store">补货中</div>
          <div v-show="product.EstimatedTime" class="activty-contdown">
            <span> 预计到货需{{ getDay(product.EstimatedTime) }}天</span>
            <span class="timer">
              <van-count-down :time="getTimer(product.EstimatedTime)">
                <template #default="timeData">
                  <span class="block">{{ timeData.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.minutes }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.seconds }}</span>
                </template>
              </van-count-down>
            </span>
          </div>
          <span
            v-if="product.ActivityInfo && product.ActivityInfo.ActivityDiscount"
            class="product-activitydiscount"
          >{{ product.ActivityInfo.ActivityDiscount }}折</span>
        </div>
        <div class="item-div-info">
          <div class="item-div-titleOne">
            <img v-if="product.IsNewProduct" src="@/assets/home/newProduct.png">
            <span class="product_title">{{ product.SkuName }}</span>
          </div>
          <div class="item-div-titleSecond">
            <span>{{ product.Specifications }}/{{ product.Unit }}</span>
          </div>
          <div class="item-div-titleSecond">
            <span>效期优于{{ product.Validity }}</span>
          </div>
          <div
            v-show="product.IsOutBusinessScope"
            class="item-div-IsOutBusinessScope"
          >
            超出经营范围
          </div>
          <div v-show="!product.IsOutBusinessScope" class="item-div-titleThree">
            <img
              v-show="
                (product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 5) ||
                  (product.ActivityInfo && product.ActivityInfo.ActivityCode == 8)
              "
              src="@/assets/home/down.png"
            >
            <span v-if="!product.IsOutBusinessScope">￥{{ product.Price }}</span>
            <span
              v-show="
                ((product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 8) ||
                  (product.ActivityInfo &&
                    product.ActivityInfo.ActivityCode == 5)) &&
                  !product.IsOutBusinessScope
              "
            >￥{{ product.Price }}</span>
            <div
              v-show="
                !product.IsOutBusinessScope&&product.ActivityInfo && product.ActivityInfo.ActivityCode == 6
              "
              class="active-price-div"
            >
              折后约￥{{ product.Price }}
            </div>
          </div>
          <div v-show="!product.IsOutBusinessScope" class="item-div-titleFour">
            <span>最低零售 ¥{{ product.RetailPrice }} | 毛利率
              {{
                _showProductProfit(
                  product.RetailPrice,
                  _getProductPrice(product.ActivityPrice, product.PriceLimit)
                )
              }}
              %</span>
          </div>
          <div v-show="!product.IsOutBusinessScope" class="item-div-titleFive">
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 8 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              秒杀
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 4 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              换购
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 3 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满赠
            </div>
            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 6 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满减
            </div>

            <div
              v-show="
                product.ActivityInfo &&
                  product.ActivityInfo.ActivityCode == 7 &&
                  !product.IsOutBusinessScope
              "
              class="miaoshatag"
            >
              满返
            </div>
            <div v-if="product.MedicalType != 0" class="typetag">
              {{
                product.MedicalType == 1
                  ? '甲类'
                  : product.MedicalType == 2
                    ? '乙类'
                    : '医保'
              }}
            </div>
            <div
              v-if="product.CountryCode && !product.IsOutBusinessScope"
              class="codetag"
            >
              国家码
            </div>
            <div v-if="!product.IsOutBusinessScope&&product.CouponInfos" class="coupon_class">
              {{ _truncature(product.CouponInfos[0].Name, 4) }}
            </div>
          </div>
          <div
            v-show="!product.IsOutBusinessScope"
            class="item-div-btn"
            @click.stop="stepper"
          >
            <van-stepper
              v-show="!product.IsOutBusinessScope && !product.IsSoldOut"
              v-model="product.Count"
              :disabled="!product.Stock"
              :min="product.StartNumber"
              :max="product.MaxNumber"
              :step="product.StepLengthNumber"
              integer
              @focus="onFocus($event)"
            />
            <div
              v-if="product.IsSoldOut"
              :class="!product.ArrivalNotice ? 'btn-notice' : 'btn-notice-read'"
              @click.stop="SubNotice()"
            >
              {{ !product.ArrivalNotice ? '到货通知' : '已订阅' }}
            </div>

            <div
              v-show="!product.IsOutBusinessScope && !product.IsSoldOut"
              class="btn"
              @click.stop="addShoppingCart(product)"
            >
              加入购物车
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'NewProductItem',
  components: {},
  mixins: [BaseMixin],
  props: {
    type: {
      type: String,
      default: () => 'vertical'
    },
    product: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cartNum: 3,
      times: 127637618,
      timesData: 3,
      notice: false,
      showInputNum: false,
      valInputNum: 0
    }
  },
  mounted() {},
  created() {},
  destroyed() {},
  methods: {
    // 显示输入框
    onFocus(e) {
      e.stopPropagation()
      this.showInputNum = true
      this.valInputNum = this.product.Count
      e.target.blur()
    },
    // 关闭输入框
    cancelNumber() {
      this.showInputNum = false
    },
    // 确认输入
    inputNumberEnter() {
      if (
        this.valInputNum > this.product.LimitPerOrder &&
        !!this.product.LimitPerOrder
      ) {
        this.$toast({
          position: 'bottom',
          message:
            '单笔订单限购（' + this.product.LimitPerOrder + '）' + this.product.Unit
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.product.Count = this.$hys.checkLimitPerOrder(
          this.product.PurchaseNumber,
          this.product.StepLengthNumber,
          this.product.LimitPerOrder
        )
        this.showInputNum = false
        return false
      }
      if (this.valInputNum < this.product.PurchaseNumber) {
        this.product.Count = this.product.PurchaseNumber
      } else if (this.valInputNum > this.product.Stock) {
        this.$toast({ position: 'bottom', message: '不能大于最大库存！' })
        this.product.Count = this.product.Stock
      } else {
        this.product.Count = this.valInputNum
      }
      this.cancelNumber()
    },
    toDetail(product) {
      this._jump(this.Enum_LinkTypeCode.ProductDetails, product.Id, '_blank')
    },
    stepper() {
      // 什么也不做
    },
    // 到货通知
    async SubNotice() {
      const data = await this.postAction(
        '/api_customer/CustomerCollect/Create',
        {
          CollectType: 3,
          CollectingBusinessId: this.product.Id,
          CollectionPrice: this._getProductPrice(
            this.product.ActivityPrice,
            this.product.PriceLimit
          )
        }
      )
      if (!data.IsSuccess) {
        this.$toast({ position: 'bottom', message: data.Msg })
      } else {
        if (data.Data) {
          this.refArrivalNotices(true)
          // this.$parent.syncCurrentSourceData(this.ListIndex, this.ActivityListIndex, this.GoodsSkusIndex, 'ArrivalNotice', true)
        }
      }
    },
    // 刷新到货通知状态
    refArrivalNotices(isNotices) {
      if (typeof this.product.ArrivalNotices !== 'undefined') {
        this.product.ArrivalNotices = isNotices
      }
      if (typeof this.product.ArrivalNotice !== 'undefined') {
        this.product.ArrivalNotice = isNotices
      }
      this.$forceUpdate()
    },
    /*
     * 数字补0方法
     * @param num {number} 需要转换的数值
     * @param size {number} 需要转换的数值长度
     * @return 补0后的数值
     */
    prefixInteger(num, size) {
      return (Array(size).join(0) + num).slice(-size)
    },
    // 获取倒计时天数
    getDay(str) {
      if (str) {
        const end = new Date(str).getTime()
        const start = new Date().getTime()
        const day = Math.floor((end - start) / 24 / 60 / 60 / 1000)
        return day
      }
    },
    getTimer(str) {
      if (str) {
        const end = new Date(str).getTime()
        const start = new Date().getTime()
        const time = end - start - 24 * 60 * 60 * 1000 * this.getDay(str)
        return time
      }
    },
    /*
     * 加入购物车
     * @param item {object} 跳转行对象
     */
    async addShoppingCart(item) {
      // 组装提交数据

      const formData = {
        ProductSKUId: item.Id, // 商品ID
        ActivityId: item.ActivityInfo ? item.ActivityInfo.ActivityId : null, // 活动ID
        Count: item.Count, // 数量
        IsAdd: true // 是否累加商品
      }
      // 调用接口
      const res = await this.postAction(
        '/api_order/ShoppingCarts/AddOrUpdateCart',
        formData
      )
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      // 判断是否可以加购
      if (res.Data.IsLimitPerOrder && !!item.SingleOrderLimitNumb) {
        const comparison = this.$hys.checkLimitPerOrder(
          item.StartNumber,
          item.StepLengthNumber,
          item.SingleOrderLimitNumb
        )
        if (comparison > item.StepLengthNumber) {
          item.Count = comparison
        } else {
          item.Count = item.StartNumber
        }
        this.$toast({
          position: 'bottom',
          message:
            '单笔订单限购（' + item.SingleOrderLimitNumb + '）' + item.Unit
        })
        return
      }
      // 添加成功
      this.$toast({
        position: 'center',
        message: '添加购物车成功'
      })
      // 添加成功，刷新顶部栏，侧边栏，悬浮购物车数量
      this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true)
      this.$bus.$emit(
        'rightBuycarChanged',
        res.Data.CountData.ProductCount,
        true
      )
    }
  }
}
</script>

<style lang="less" scoped>
@import url('~@/views/storey/style/NewProductItem');

/deep/ .van-stepper {
  border: 1px solid #C5CAD5;
  border-radius: 2px;
  height: 34px;

  .van-stepper__input {
    margin: 0;
    border-right: 1px solid #C5CAD5;
    border-left: 1px solid #C5CAD5;
    width: 47px;
    height: 32px;
    font-size: 14px;
    background-color: #FFFFFF;
  }
}

/deep/.van-stepper__minus {
  width: 35px;
  font-size: 10px;
  color: #41485D;
  background-color: #FFFFFF;
}

/deep/.van-stepper__plus {
  width: 35px;
  font-size: 10px;
  color: #41485D;
  background-color: #FFFFFF;
}

.product-activitydiscount {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-block;
  border: 1px solid #FF3939;
  border-radius: 12px;
  width: 64px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #FF3939;
  background: #FFF1F1;
}

.inputNumber {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999999999999;
  background-color: rgba(0, 0, 0, .7);

  &-d {
    position: absolute;
    top: 30%;
    display: flex;
    align-items: flex-start;
    margin-left: 25vw;
    border-radius: 15px;
    padding: 20px 20px 10px;
    width: 50vw;
    height: 137px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    flex-direction: column;
  }

  &-amout {
    margin-bottom: 10px;
  }

  &-input {
    border: none;
    border-bottom: 1px #FF5500 solid;
    width: 100%;
  }

  &-bottons {
    margin-top: 10px;
    width: 100%;
    cursor: pointer;
  }

  .input-enter,
  .input-cancel {
    float: right;
    margin-left: 30px;
    padding: 10px 0;
    color: rgb(255, 85, 0);
  }
}
</style>
